import React, { Component } from "react";
import FlipMove from "react-flip-move";
import styled from "styled-components";

import JobCard from "./JobCard";

const JobCardWrapper = styled.div`
  margin: 1rem 0;
`;

class JobCardList extends Component {
  state = {
    activeJob: ""
  };

  toggleActive(jobId) {
    this.setState(prevState => {
      if (jobId === prevState.activeJob) {
        return { activeJob: "" };
      }
      return { activeJob: jobId };
    });
  }

  isActive(jobId) {
    if (this.state.activeJob === jobId) {
      return true;
    }
    return false;
  }
  jobs() {
    return this.props.jobs.map(job => (
      <JobCardWrapper key={job.id}>
        <JobCard
          toggleActive={() => this.toggleActive(job.id)}
          {...job}
          active={this.isActive(job.id)}
        />
      </JobCardWrapper>
    ));
  }
  render() {
    return (

        <FlipMove duration={300} easing="ease-out">
          {this.jobs()}
        </FlipMove>
    );
  }
}

export default JobCardList;



// WEBPACK FOOTER //
// ./src/components/Jobs/JobCardList.js